Wee.fn.extend('commerce', {
	_construct: function() {
		this.sameAddressNamespace = 'toggleBillingAddress';
	},

	/**
	 * Init toggle billing address
	 *
	 * @param {object} options
	 * @param {string} [options.billingAddressSelector=ref:billingAddress]
	 * @param {string} [options.checkboxSelector=ref:sameAddress]
	 */
	initSameAddressToggle: function(options) {
		var priv = this.$private,
			settings = $.extend({
				billingAddressSelector: 'ref:billingAddress',
				checkboxSelector: 'ref:sameAddress'
			}, options);

		priv.sameAddressSettings = settings;

		priv.toggleBillingAddress();

		$(settings.checkboxSelector).on('change.' + this.sameAddressNamespace, function() {
			priv.toggleBillingAddress();
		});
	},

	/**
	 * Destroy toggle billing address events
	 */
	destroySameAddressToggle: function() {
		$.events.off(false, '.' + this.sameAddressNamespace);
	}
}, {
	/**
	 * Toggle billing address
	 *
	 * @private
	 */
	toggleBillingAddress: function() {
		var settings = this.sameAddressSettings,
			$address = $(settings.billingAddressSelector),
			$checkbox = $(settings.checkboxSelector);

		if ($checkbox.prop('checked')) {
			$address.hide();

			$address.find('[data-required]')
				.removeAttr('data-required')
				.data('not-required', '');
		} else {
			$address.show();

			$address.find('[data-not-required]')
				.removeAttr('data-not-required')
				.data('required', '');
		}
	}
});